import { Injectable } from '@angular/core';
import { HIDE_DIALOG_DELAY } from '@lx/quote-tool/lite/shared/types';

/**
 * Service to handle side panel operations.
 *
 * This service is responsible for closing the side panel and providing a callback mechanism.
 */
@Injectable({
  providedIn: 'root',
})
export class SidePanelService {
  hidePanel(callback?: () => void) {
    // Close with a delay to allow users see the selected option before hiding the dialog
    // (emulating what it is defined on Figma design)
    setTimeout(() => {
      if (callback) {
        callback();
      }
    }, HIDE_DIALOG_DELAY);
  }
}
